module.exports = __webpack_public_path__ + "static/img/fishGame4.a5a0825.webp";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/fishGame4.webp
// module id = 5MYu
// module chunks = 3